// TODO: This should probably be ints instead of strings
export enum TicketStatusEnum {
  New = "0",
  Acknowledged = "1",
  Resolved = "2",
  Closed = "3",
  HoldWaitForOwner = "4",
  Reopened = "5",
  Merged = "6",
  Canceled = "7",
  HoldWaitForExternal = "8",
  HoldWaitForApprover = "9",
  Approved = "10",
  Rejected = "11",
  Escalated = "12",
}

export interface TicketStatus {
  id: string;
  departmentId: string;
  name: string;
  systemName?: string;
  isEnabled: boolean;
}

export const allTicketStatusesIds = Object.values(TicketStatusEnum);

export const inWorkStatusesIds = [
  TicketStatusEnum.New,
  TicketStatusEnum.Acknowledged,
  TicketStatusEnum.Escalated,
  TicketStatusEnum.Reopened,
  TicketStatusEnum.HoldWaitForOwner,
  TicketStatusEnum.HoldWaitForExternal,
  TicketStatusEnum.HoldWaitForApprover,
  TicketStatusEnum.Approved,
  TicketStatusEnum.Rejected,
];

export const closedStatusesIds = [TicketStatusEnum.Resolved, TicketStatusEnum.Closed, TicketStatusEnum.Canceled, TicketStatusEnum.Merged];

export const allowedTicketRequestStatusesForSelection = [
  TicketStatusEnum.Acknowledged,
  TicketStatusEnum.Escalated,
  TicketStatusEnum.Resolved,
  TicketStatusEnum.Approved,
  TicketStatusEnum.Rejected,
  TicketStatusEnum.Canceled,
  TicketStatusEnum.HoldWaitForExternal,
  TicketStatusEnum.HoldWaitForOwner,
];

export const allowedTicketIncidentStatusesForSelection = [
  TicketStatusEnum.Acknowledged,
  TicketStatusEnum.Escalated,
  TicketStatusEnum.Resolved,
  TicketStatusEnum.Canceled,
  TicketStatusEnum.HoldWaitForOwner,
];

export const groupedTicketStatusOptions = [
  {
    name: "In lucru",
    value: inWorkStatusesIds.sort(),
  },
  {
    name: "Inchise",
    value: closedStatusesIds.sort(),
  },
];
